import type { AuthRepositoryPort } from "../ports/auth.repository.port";

export function setPasswordUseCase(repository: AuthRepositoryPort, password: string) {
  return repository.setPassword(password);
}
